import { Routes } from '@angular/router';
import { AuthGuard } from '../_guard/auth.guard';


export const routes: Routes = [
  {
    path: '', loadComponent: () => import('./reports.component').then(m => m.ReportsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'technical-supervision', loadComponent: () => import('./technical-supervision/technical-supervision.component').then(m => m.TechnicalSupervisionComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'gask', loadComponent: () => import('./gask/gask.component').then(m => m.GaskComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'organizations', loadComponent: () => import('@app/reports/organization-reports/organization-reports.component').then(m => m.OrganizationReportsComponent),
    canActivate: [AuthGuard]
  },
];
